const Pizza = () => {
	return (
		<div class="menu">
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Pizza-2.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1666933882803"
				alt="Pizza"
			/>
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Pizza-1.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1666934090237"
				alt="Pizza"
			/>
		</div>
	);
};

export default Pizza;
